import React from "react";
import { RiTimeFill } from "react-icons/ri";
import { FaComments } from "react-icons/fa";
import { HiShare } from "react-icons/hi";
import { Link, useSearchParams } from "react-router-dom";
import {
  getPosts,
  getPageSize,
  blogImageUrl,
  blogPostLink,
} from "../utils/blogs";

const AllBlogs = ({ isBg }) => {
  const [searchParams] = useSearchParams();
  const posts = getPosts();
  const pageSize = getPageSize();
  const totalPages = Math.max(1, Math.ceil(posts.length / pageSize));

  const requested = parseInt(searchParams.get("page"), 10);
  const currentPage = Number.isNaN(requested)
    ? 1
    : Math.min(Math.max(requested, 1), totalPages);

  const pagePosts = posts.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const pageLink = (page) => `/all-blog?page=${page}`;

  return (
    <>
    <section
      id="media"
      className={`section-padding ${isBg === "yes" ? "bg-one" : ""}`}
      style={{padding:"100px 0 0 0"}}
    >
      <div className="container">
        <div className="row">
          <div className="col-xl-6 offset-xl-3 col-lg-10 offset-lg-1">
            <div className="section-title-center text-center">
              <span></span>
              <h2 className="display-6">Book Reviews</h2>
              <div className="section-divider divider-traingle"></div>
            </div>
          </div>
        </div>

          </div>
    </section>
    <section
      id="blog"
      className={`section-padding blog ${isBg === "" ? "bg-one" : ""}`}
    >
      <div className="container">
        <div className="row">
          {pagePosts.map((post, i) => (
            <div
              key={post.id}
              className="col-md-6 col-lg-4 mb-4"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay={(i + 2) * 50}
            >
              <article className="blog__single-post h-100 translateEffect1">
                <div className="blog__single-post__image">
                  <Link to={blogPostLink(post)}>
                    <img
                      className="img-fluid"
                      src={blogImageUrl(post.image)}
                      alt={post.title}
                    />
                  </Link>
                </div>
                <div className="blog__single-post__body">
                  <div className="blog__single-post__content">
                    <h2 className="fs-4">
                      <Link to={blogPostLink(post)}>{post.title}</Link>
                    </h2>
                    <p className="m-0">{post.description}</p>
                  </div>
                  <div className="blog__single-post__meta">
                    <div className="d-flex gap-2 align-items-center">
                      <RiTimeFill />
                      {post.date}
                    </div>
                    {/* <ul>
                      <li>
                        <FaComments />
                      </li>
                      <li>
                        <HiShare />
                      </li>
                    </ul> */}
                  </div>
                </div>
              </article>
            </div>
          ))}
        </div>
        {totalPages > 1 && (
          <div className="blog__pagination">
            <nav aria-label="Blog pagination">
              <ul className="pagination">
                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                  <Link
                    className="page-link"
                    to={pageLink(Math.max(1, currentPage - 1))}
                    aria-label="Previous"
                  >
                    <span aria-hidden="true">&laquo;</span>
                  </Link>
                </li>
                {Array.from({ length: totalPages }, (_, n) => n + 1).map(
                  (page) => (
                    <li
                      key={page}
                      className={`page-item ${page === currentPage ? "active" : ""}`}
                    >
                      <Link
                        className="page-link"
                        to={pageLink(page)}
                        aria-current={page === currentPage ? "page" : undefined}
                      >
                        {page}
                      </Link>
                    </li>
                  )
                )}
                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <Link
                    className="page-link"
                    to={pageLink(Math.min(totalPages, currentPage + 1))}
                    aria-label="Next"
                  >
                    <span aria-hidden="true">&raquo;</span>
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        )}
      </div>
    </section>
     </>
     // <!-- ========== blogs section end ========== -->
  );
};

export default AllBlogs;
